<template>
    <!-- <AddButton btnname="Add New" class=" float-rights " v-if="showButton" @click="IsCreate()">
        Add New
    </AddButton>
    <EditIcon v-if="!showButton" @click="IsEditpop()">Edit</EditIcon> -->
    <Dialog v-model:visible="triggers" :closable="false" :modal="true" :header="$t('Payment.title')"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '70vw' }">
        <template #header>
            <b-row class="border-line">
                <b-col>
                    <h6>Confirmation</h6>
                </b-col>
                <b-col class="d-flex flex-row-reverse">
                    <i class="pi pi-times" @click="$emit('Ok')"></i>
                    <!-- <i icon="pi pi-times" @click="$emit('Ok')" /> -->
                </b-col>
            </b-row>
        </template>
        <b-row>
            <b-col class="pb-5">
                <span class="light-txt">{{ quotecompare.SupplierCode }}</span>
                <p class="component-heading">{{ quotecompare.SupplierName }}</p>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-row class="py-3">
                    <b-col lg="4" class="bold-heading">Overall value</b-col>
                    <b-col lg="8" class="right-align bold-heading">₹{{ quotecompare.Overallvalue }}</b-col>
                </b-row>
                <b-row class="py-3">
                    <b-col lg="4" class="light-txt">% of free by value</b-col>
                    <b-col lg="8" class="right-align bold-heading">{{ quotecompare.FreeQty }}</b-col>
                </b-row>
                <b-row class="py-3">
                    <b-col lg="4" class="light-txt">Effective Tax</b-col>
                    <b-col lg="8" class="right-align bold-heading">{{ quotecompare.EffectiveTo == null ? 0 :
                        quotecompare.EffectiveTo
                        }}</b-col>
                </b-row>
                <b-row class="py-3">
                    <b-col lg="4" class="light-txt">Discount</b-col>
                    <b-col lg="8" class="right-align bold-heading">{{ quotecompare.Discount }}%</b-col>
                </b-row>
                <b-row class="py-3">
                    <b-col lg="4" class="light-txt">Landing cost</b-col>
                    <b-col lg="8" class="right-align bold-heading">{{ quotecompare.LendingRate }}</b-col>
                </b-row>
                <b-row class="py-3">
                    <b-col lg="4" class="light-txt">Payment terms</b-col>
                    <b-col lg="8" class="right-align bold-heading">{{ quotecompare.PaymentTermsDesc }}</b-col>
                </b-row>
                <b-row class="py-3">
                    <b-col lg="4" class="light-txt">Delivery Terms</b-col>
                    <b-col lg="8" class="right-align bold-heading">{{ quotecompare.DeliTermsDesc == '' ? '--'
                        : quotecompare.DeliTermsDesc
                        }}
                        <!-- <span class="back">&
                            1
                            another</span> -->
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="py-5">
                <div class="field">
                    <Textareas :requiredIcon="false" placeholder=" " v-model="quotecompare.Remarks" name="Reamrks"
                        id="Remarks" label="Remarks" :rules="{ required: false, alphanumeric: true }" />
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="d-flex flex-row-reverse">
                <AddButton btnname="Confirm and Send for PO" @click="$emit('sendpo')" />
                <cancel @canclebtn="$emit('ok')" />
            </b-col>
        </b-row>
    </Dialog>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, reactive } from "vue";

// import Footer from "./components/footer/footer.vue";
import PaymentTermsService from "../../../../../modules/Inventory/Service/PaymentTermsService";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import NumberField from "../../../../../components/FormComponents/InputNumber.vue";
import Textareas from "../../../../../components/FormComponents/TextArea.vue";
import { useForm } from "vee-validate";
import { useI18n } from 'vue-i18n';
import cancel from "../../../../../components/GeneralButtons/CancelButtton.vue";


export default defineComponent({
    props: {
        triggers: {
            readonly: false,
            type: Boolean,
            default: ref(false),
        },
        selectedItem: {
            type: Object,
            Default: () => { },
        },
        showButton: {
            type: Boolean,
            Required: true,
        },
    },
    components: {


        TextField,
        Textareas,
        NumberField,
        cancel
    },
    setup(props, { emit }) {
        const quotecompare = reactive({

            Remarks: '',
            SupplierName: '',
            SupplierId: 0,
            SupplierCode: '',
            Overallvalue: '',
            FreeQty: '',
            EffectiveTo: '',
            Discount: '',
            LendingRate: 0,
            PaymentTermsDesc: '',
            DeliTermsDesc: ""
        })
        function update() {

            emit("update:modelValue", quotecompare);
        }
        onMounted(() => {
            // Object.assign(SupformData, props.value);
            quotecompare.Remarks = ''
            update();
        });
        return {
            update,
            quotecompare

        };
    },
});
</script>

<style>
.right-align {
    text-align-last: right;
}

.border-line {
    padding-bottom: 10px;
    border-bottom: 1px solid #e1e1e1;
}
</style>
